import DetailAccessibilityBottomContainer from '@components/atoms/container/detailAccessibilityBottomContainer';
import DetailAccessibilityContainer from '@components/atoms/container/detailAccessibilityContainer';
import DetailButtons from './detailButtons';
import DetailContext from '@shared/components/utils/context/detailContext';
import DetailDescriptionUpgradablePlanContainer from '@components/atoms/container/detailDescriptionUpgradablePlanContainer';
import Direction from '@shared/types/enums/direction';
import Score from '../rating/score';
import Tip from '../tip/tip';
import UpgradablePlan from '../plan/upgradablePlan';
import { useContext } from 'react';

export default function DetailAccessibility() {
  const { assetInfo } = useContext(DetailContext);
  if (assetInfo) {
    const { commercialScoreText, upgradablePlan } = assetInfo;
    return (
      <DetailAccessibilityContainer id='detailAccessibility'>
        <Score score={commercialScoreText} />
        <DetailAccessibilityBottomContainer>
          {upgradablePlan ? (
            <DetailDescriptionUpgradablePlanContainer id='upgradablePlan'>
              <UpgradablePlan
                direction={Direction.VERTICAL}
                fontSize={42}
                plan={upgradablePlan}
              />
              <DetailButtons />
            </DetailDescriptionUpgradablePlanContainer>
          ) : (
            <Tip />
          )}
        </DetailAccessibilityBottomContainer>
      </DetailAccessibilityContainer>
    );
  }
}
